import $ from 'jquery';
import slick from 'slick-carousel';
import hoverintent from 'hoverintent';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

const slickUseTransform = $('body').hasClass('ie') ? false : true;

/**
 * Hero Slideshow
 */
function initHeroSlideshow() {
	const heroes = $(".hero");
	heroes.each(function() {
		const slides = $(this).find(".hero-slides");
		if(slides.length > 0) {
			slides.slick({
				autoplay: true,
				autoplaySpeed: 6000,
				speed: 4000,
				arrows: false,
				draggable: false,
				fade: true,
				pauseOnFocus: false,
				pauseOnHover: false,
				swipe: false,
				touchMove: false,
				useTransform: slickUseTransform
			});
		}
	});
};

/**
 * Thumbnail Carousel
 */
function initThumbnailCarousels() {

	$(".thumbnail-carousel").each(function() {
		const tc = $(this);
		const thumbs = tc.find(".thumbnails > .thumbnail");
		const carousel = tc.find(".carousel");

		carousel.slick({
			arrows: false,
			speed: constants.speed,
			draggable: false,
			cssEase: constants.easing,
			useTransform: slickUseTransform
		});

		thumbs.each(function(i) {
			if(i === 0) {
				$(this).addClass("active");
			}
			$(this).click(function(e) {
				if(els.viewport.width() >= breakpoints.md) {
					e.preventDefault();
					thumbs.parent().find(".active").removeClass("active");
					$(this).addClass("active");
					carousel.slick("slickGoTo", i);
					helpers.scrollToEl(tc, 40);
				}
			});

			const thumb = $(this)[0];

			hoverintent(
				thumb,
				function() {
					$(thumb).addClass('hover');
					$(thumb).removeClass('hovered-last');
				},
				function() {
					$(thumb).removeClass('hover');
					$(thumb).siblings().removeClass("hovered-last");
					$(thumb).addClass('hovered-last');
				}
			);
		});
	});
};

/**
 * Helper jQuery plugin to toggle between style and class attributes.
 * @param  {[type]} action
 */
$.fn.toggleStyles = function(action) {

	return this.each(function() {
		var el = $(this);

		if(action === "toggle") {
			var newClasses = el.attr("data-toggle-class");
			var oldClasses = el.attr("class");
			el.attr("data-orig-class", oldClasses);
			el.attr("class", newClasses);

			if(el.attr("data-toggle-style")) {
				el.attr("style", el.attr("data-toggle-style"));
			}

			el.attr("data-toggle-status", "toggled");
		} else if(action === "revert") {
			el.attr("class", el.attr("data-orig-class"));

			if(el.attr("data-toggle-style")) {
				el.removeAttr("style");
			}

			el.attr("data-toggle-status", "reverted");
		}
	});
};

/**
 * Function to build a slick carousel on the fly.
 * @param  {[type]} slides
 */
function buildSlick(slides) {

	var slickOpts = {
		adaptiveHeight: true,
		speed: constants.speed,
		cssEase: constants.easing,
		prevArrow: "<span class='carousel-control prev'><i class='fa fa-angle-left'></i></span>",
		nextArrow: "<span class='carousel-control next'><i class='fa fa-angle-right'></i></span>",
		useTransform: slickUseTransform
	};

	var controls;

	if(slides.siblings(".carousel-controls").length === 0) {
		var controlsClass = "carousel-controls";
		controls = $("<div class='" + controlsClass + "'></div>");
		slides.after(controls);
	} else {
		controls = slides.siblings(".carousel-controls");
	}

	slickOpts.appendArrows = controls;
	slides.slick(slickOpts);
}

/**
 * Default Carousels
 */
function handleDefaultCarouselView() {
	const carousels = $(".default-carousel");

	carousels.each(function() {
		const carousel = $(this);
		const slides = carousel.find("[data-slides]");
		const slidesBreakpoint = parseInt(slides.attr("data-carousel-breakpoint"));

		if(slidesBreakpoint) {
			const toggleEls = carousel.find("[data-toggle-class], [data-toggle-style]");
			const toggleStatus = toggleEls.first().attr("data-toggle-status");

			if(els.viewport.width() >= slidesBreakpoint) {
				if(slides.hasClass("slick-initialized")){
					slides.slick("unslick");
				}
				if(toggleStatus === undefined || toggleStatus === "reverted") {
					toggleEls.toggleStyles("toggle");

					if(slides.hasClass("masonry-grid") && !slides.hasClass("wrapped")) {
						const blocksToWrap = slides.find("> div:not(:first)");
						blocksToWrap.wrapAll("<div class='masonry-grid' />");
						slides.addClass("wrapped");
					}
				}
			} else {
				if(toggleStatus === undefined || toggleStatus === "toggled") {
					slides.find("> .masonry-grid").contents().unwrap();
					toggleEls.toggleStyles("revert");
				}
				if(!slides.hasClass("slick-initialized")){
					buildSlick(slides);
				}
			}
		} else if(!slides.hasClass("slick-initialized")) {
			buildSlick(slides);
		}
	});
};

function initTabSliders() {
	$('.tab-slider').each(function() {
		var slider = $(this);

		// add elements to add slick dots to
		slider.before('<nav class="tab-slider__nav" role="navigation"></nav>');

		// store elements for future use
		var sliderNav = slider.prev();

		// initialize page slider
		slider.slick({
			adaptiveHeight: true,
			arrows: false,
			appendDots: sliderNav,
			customPaging : function(slider, i) {
				return '<span>' + $(slider.$slides[i]).data('label') + '</span>';
			},
			dots: true,
			dotsClass: 'tab-slider__controls',
			draggable: false,
			useTransform: slickUseTransform
		});
	});
}

window.addEventListener('load', (e) => {
	initHeroSlideshow();
	initThumbnailCarousels();
	handleDefaultCarouselView();
	initTabSliders();
});

window.addEventListener('resize', helpers.debounce(handleDefaultCarouselView));
